

export class MapOutputWithStatus implements IMapOutputWithStatus {
    /** The auto-generated id of the map master */
    map_id!: number;
    /** The map name with 255 character limit */
    map_name!: string;
    /** Manage status of map. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IMapOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.map_id = _data["map_id"];
            this.map_name = _data["map_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MapOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MapOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["map_id"] = this.map_id;
        data["map_name"] = this.map_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IMapOutputWithStatus {
    /** The auto-generated id of the map master */
    map_id: number;
    /** The map name with 255 character limit */
    map_name: string;
    /** Manage status of map. 0 For De-active, 1 For Active */
    status: number;
}

